<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  status: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();

const STATUS_CLASSES = {
  open: 'bg-n-teal-9/15 dark:bg-n-teal-9/20',
  resolved: 'bg-n-slate-9/15 dark:bg-n-slate-9/20',
  pending: 'bg-n-amber-9/20 dark:bg-n-amber-9/25',
  queued: 'bg-n-iris-9/15 dark:bg-n-iris-9/20',
  snoozed: 'bg-n-blue-9/15 dark:bg-n-blue-9/20',
};

const label = computed(() => {
  if (!props.status) return '';
  return t(`CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.${props.status}.TEXT`);
});

const colorClasses = computed(
  () => STATUS_CLASSES[props.status] || STATUS_CLASSES.open
);
</script>

<template>
  <span
    v-if="status"
    class="conversation-status-badge inline-flex items-center px-1.5 py-px rounded text-xxs font-medium leading-4 whitespace-nowrap !text-black dark:!text-white"
    :class="colorClasses"
  >
    {{ label }}
  </span>
</template>
